export default "__VITE_ASSET__CZQUpT$N__"